import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import useHtmlMeta from '~/composables/useHtmlMeta';
import { useCart } from '~/composables/useCart';
import { useUser } from '~/composables/_next/useUser';
import Toaster from '~/components/Layout/Toaster.vue';
export default defineComponent({
  name: 'BlankLayout',
  components: {
    Toaster: Toaster
  },
  setup: function setup() {
    var _useUser = useUser(),
      loadUser = _useUser.load;
    var _useCart = useCart(),
      loadCart = _useCart.load;
    var _useHtmlMeta = useHtmlMeta(),
      setHtmlLocale = _useHtmlMeta.setHtmlLocale;
    setHtmlLocale();
    loadUser();
    loadCart();
    useLazyAsyncData('layouts-blank', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", true);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    useHead({
      title: 'Aroma-Zone'
    });
  }
});